export const STORAGE_KEY = 'KitGroupClient'



// WEBPACK FOOTER //
// ./src/vuex/state/config.js